<template>
  <div>
    <video
      v-show="visible"
      ref="stream"
      autoplay
    />
  </div>
</template>

<script lang="">
import { mapGetters } from 'vuex'

export default {
  data () {
    return {}
  },
  props    : [],
  computed : {
    ...mapGetters('video/stream', [
      'visible',
      'boardStream'
    ])
  },
  methods : {},
  watch   : {
    boardStream (stream) {
      this.$refs.stream.srcObject = stream
    }
  }
  // Options / DOM
  // el () {},
  // replace: true,
  // template: '',
  // Options / Lifecycle Hooks
  // init () {},
  // crated () {},
  // beforeCompile () {},
  // compiled () {},
  // ready () {},
  // attached () {},
  // detached () {},
  // beforeDestroy () {},
  // destroyed () {},
  // Options / Assets
  // directives: {},
  // elementDirectives: {},
  // filters: {},
  // components: {},
  // transitions: {},
  // partials: {},
  // Options / Misc
  // parent: null,
  // events: {},
  // mixins: [],
  // name: ''
}
</script>



// WEBPACK FOOTER //
// src/components/video/content/stream.vue